// GA4 ecommerce contract for the pre-checkout funnel.
// Source of truth: wanderu/strategy engineering/initiatives/ga4-ecommerce-remarketing/
// sub-initiatives/event-contract.md. Values here are load-bearing downstream:
// the sGTM margin template branches on `item_category`, and Google Ads reads
// `google_business_vertical` off the items.
//
// The contract's other `item_category`, `insurance`, has no emitter here by
// design: insurance is a checkout step, not a Trip Summary add-on, and
// `purchase` already reports it as its own event.

// Where a Book click sends the traveler: a partner deep link hands them to the
// carrier's own site, everything else stays on a Wanderu checkout. Split out so
// conversion-rate analyses are not comparing the two as one funnel.
const CHECKOUT_DESTINATION_CARRIER = 'carrier';
const CHECKOUT_DESTINATION_WANDERU = 'wanderu';

const CURRENCY_USD = 'USD';

const GOOGLE_BUSINESS_VERTICAL = 'travel';

const ITEM_CATEGORY_TICKET = 'ticket';

const ITEM_LIST_ID_SEARCH_RESULTS_DEPART = 'search_results_depart';
const ITEM_LIST_ID_SEARCH_RESULTS_RETURN = 'search_results_return';

const ITEM_LIST_NAME_SEARCH_RESULTS_DEPART = 'Search results (depart)';
const ITEM_LIST_NAME_SEARCH_RESULTS_RETURN = 'Search results (return)';

// GA4 reads the list id and the list name as one dimension, so they are paired
// here rather than passed separately by call sites -- nothing can send a name
// that disagrees with its id. One constant name per list: route, query and
// filter detail belong in the items, never in the name.
const ITEM_LIST_NAMES: Record<string, string> = {
    [ITEM_LIST_ID_SEARCH_RESULTS_DEPART]: ITEM_LIST_NAME_SEARCH_RESULTS_DEPART,
    [ITEM_LIST_ID_SEARCH_RESULTS_RETURN]: ITEM_LIST_NAME_SEARCH_RESULTS_RETURN,
};

const LEG_ROLE_DEPART = 'depart';
const LEG_ROLE_RETURN = 'return';

const MATCH_TYPE_DIRECT = 'direct';
const MATCH_TYPE_MIXED = 'mixed';
const MATCH_TYPE_NEARBY = 'nearby';

const MODE_MIXED = 'mixed';

export {
    CHECKOUT_DESTINATION_CARRIER,
    CHECKOUT_DESTINATION_WANDERU,
    CURRENCY_USD,
    GOOGLE_BUSINESS_VERTICAL,
    ITEM_CATEGORY_TICKET,
    ITEM_LIST_ID_SEARCH_RESULTS_DEPART,
    ITEM_LIST_ID_SEARCH_RESULTS_RETURN,
    ITEM_LIST_NAMES,
    ITEM_LIST_NAME_SEARCH_RESULTS_DEPART,
    ITEM_LIST_NAME_SEARCH_RESULTS_RETURN,
    LEG_ROLE_DEPART,
    LEG_ROLE_RETURN,
    MATCH_TYPE_DIRECT,
    MATCH_TYPE_MIXED,
    MATCH_TYPE_NEARBY,
    MODE_MIXED,
};
